"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationService = void 0;
const TWEEN = __importStar(require("@tweenjs/tween.js"));
const pubsub_js_1 = require("pubsub-js");
class AnnotationService {
    constructor(webgl, apiService, annotations) {
        this.isEditable = false;
        this.camTween = null;
        this.orbitTween = null;
        this.webgl = webgl;
        this.apiService = apiService;
        this.annotations = annotations;
        for (const ann of annotations) {
            this.webgl.addObject(ann.group, true);
        }
        this.hideAnnotationHotspots();
    }
    get(manualId) {
        const annotation = this.annotations.find(ann => ann.manualId === manualId);
        if (!annotation) {
            return null;
        }
        return annotation;
    }
    showAnnotationHotspots() {
        for (const annotation of this.annotations) {
            annotation.annotationHotspot.show();
        }
        this.webgl.renderOnce();
    }
    hideAnnotationHotspots() {
        for (const annotation of this.annotations) {
            annotation.annotationHotspot.hide();
        }
        this.show(undefined);
        this.webgl.renderOnce();
    }
    /**
     * Get the highest annotation order number
     * First orderNumber should be 0, it will fail on orderNumber[ 0, 1, 3 ]
     * @returns
     */
    getHighestOrderNumber() {
        // Annotations start with 1
        let number = 1;
        if (this.annotations.length > 0) {
            number = Math.max(...this.annotations.map((item) => item.orderNumber ? item.orderNumber : 0), 0);
            number += 1;
        }
        return number;
    }
    /**
     * Add annotation to the scene
     * @param annotation
     * @returns
     */
    add(annotation) {
        if (annotation.imageId) {
            annotation.loadingImage = true;
            this.apiService.getImage(annotation.imageId).then(blobUrl => {
                annotation.addImage(annotation.imageId, blobUrl);
                annotation.loadingImage = false;
            });
        }
        this.annotations.push(annotation);
        this.webgl.addObject(annotation.group, true);
        PubSub.publish("annotation-added" /* ANNOTATION_ADDED */, annotation);
    }
    addAll(annotations) {
        for (const annotation of annotations) {
            this.add(annotation);
        }
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            const modelId = this.webgl.loadedObjectsIds[0].key;
            // Save images that are assigned to annotations before saving annotation itself
            // because a image id is needed to be saved in annotation content
            for (const annotation of this.annotations) {
                if (!annotation.imageFile) {
                    continue;
                }
                const rsp = yield this.uploadImageFile(annotation.imageFile);
                annotation.imageId = rsp.resourceId;
            }
            return this.apiService.saveAnnotations(this.annotations, modelId)
                .then((annotations) => {
                this.annotations.forEach(annotation => {
                    // TODO: remove image info from content?
                    const match = annotations.annotations.find((newAnnotation) => newAnnotation.manualId === annotation.manualId);
                    if (match) {
                        annotation.id = match.id;
                    }
                });
            });
        });
    }
    uploadImageFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file);
            return this.apiService.uploadImage(formData);
        });
    }
    goToHotSpot(annotation) {
        if (this.isEditable) {
            // Show annotation text without the animation to position
            this.show(annotation.manualId);
            return;
        }
        const duration = 1000;
        if (this.camTween && this.orbitTween) {
            this.webgl.stopRendering();
            this.camTween.stop();
            this.orbitTween.stop();
        }
        this.show(undefined);
        this.webgl.startRendering();
        this.camTween = new TWEEN.Tween(this.webgl.camera.position)
            .to(annotation.cameraPoint, duration)
            .easing(TWEEN.Easing.Circular.Out)
            .start();
        this.orbitTween = new TWEEN.Tween(this.webgl.orbitControls.target)
            .to(annotation.annotationPoint, duration)
            .easing(TWEEN.Easing.Circular.Out)
            .onComplete(() => {
            this.show(annotation.manualId);
            this.webgl.stopRendering();
            this.camTween = null;
            this.orbitTween = null;
        })
            .start();
    }
    show(manualId) {
        this.annotations.forEach(annotation => {
            annotation.annotationPopover.element.visible = false;
            if (manualId !== undefined && annotation.manualId === manualId) {
                //Scroll to the top
                //Doesn't work without timeout and I have no idea why
                setTimeout(() => {
                    annotation.annotationPopover.element.element.children[0].scrollTo({ top: 0, left: 0, behavior: 'smooth', });
                }, 0);
                annotation.annotationPopover.element.visible = true;
            }
        });
        this.webgl.renderOnce();
    }
    saveToList(item) {
        this.annotations.forEach(annotation => {
            if (annotation.manualId === item.manualId) {
                annotation = item;
            }
        });
        return this;
    }
    getByOrderNumber(orderNumber) {
        var _a;
        const annotation = (_a = this.annotations) === null || _a === void 0 ? void 0 : _a.find((ann) => ann.orderNumber === parseInt(orderNumber));
        if (!annotation) {
            return null;
        }
        return annotation;
    }
    changeOrderNumber(prevIndex, newIndex, direction) {
        //We add +1 to newIndex because annotations start with 1 and not 0
        this.annotations[prevIndex].orderNumber = newIndex + 1;
        if (direction === 'up') {
            for (let i = newIndex; i < prevIndex; i++) {
                this.annotations[i].orderNumber += 1;
            }
        }
        else {
            for (let i = prevIndex + 1; i <= newIndex; i++) {
                this.annotations[i].orderNumber -= 1;
            }
        }
        this.annotations.sort(this.annotationComparison);
        this.annotations.forEach(annotation => {
            (0, pubsub_js_1.publish)("annotation-update" /* ANNOTATION_UPDATE */, annotation);
        });
    }
    removeAnnotationByIndex(index) {
        this.annotations.splice(index, 1);
        for (let i = index; i < this.annotations.length; i++) {
            this.annotations[i].orderNumber -= 1;
        }
    }
    annotationComparison(a, b) {
        if (a.orderNumber < b.orderNumber) {
            return -1;
        }
        else if (a.orderNumber > b.orderNumber) {
            return 1;
        }
        return 0;
    }
}
exports.AnnotationService = AnnotationService;
